import * as Stimulus from "@hotwired/stimulus"

/**
 * The action buttons over a table of selectable rows.
 *
 * Selection itself belongs to SelectAllController, which shares the same
 * checkboxes. It publishes no event when the set changes, so this controller
 * listens to the same clicks: every selectable runs "refresh", including the
 * ones SelectAllController clicks on the user's behalf.
 *
 * The "selectable" targets should run "refresh" when clicked.
 */
export class BulkActionsController extends Stimulus.Controller {
    static get targets() {
        return [
            "selectable",
            "action",
            "count",
        ];
    }

    connect() {
        this.refresh();
    }

    // A row edit redraws the page by morphing it, and the new markup has every
    // box unchecked. Keeping the live state means fixing one refused row does not
    // throw away the selection it was refused from.
    keepSelection(event) {
        const $el = event.target;
        if ($el instanceof HTMLInputElement && $el.type === "checkbox" && event.detail.attributeName === "checked") {
            event.preventDefault();
        }
    }

    refresh() {
        const count = this.selectedCount();

        this.countTargets.forEach($el => { $el.textContent = count });
        this.actionTargets.forEach($el => { $el.disabled = count === 0 });
    }

    selectedCount() {
        return this.selectableTargets.filter($el => $el.checked).length;
    }
}
